import React from 'react';

function Unauthorized() {
  return (
    <div className="min-h-[calc(80vh-95px)] flex items-center justify-center ">
      <div className="bg-white p-4 rounded-lg shadow-md max-w-md text-center">
        <h4 className="text-2xl font-bold text-red-600 mb-4">Access Denied</h4>
        <p className="text-gray-700 mb-6">
          You are not authorized to access this page. This page is meant for
          students. Please contact the Admin if you believe this is a mistake.
        </p>
        <button
          onClick={() => (window.location.href = '/')}
          className="bg-secondary text-white px-6 py-3 rounded-full transition duration-300"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
}

export default Unauthorized;
